






import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {ActiveInject, ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.5.0
 * @changelog 4.5.0 Published.
 */
@Component({
    components: {}
})
export default class JdsPipelineStageBadge extends Vue {
    @Prop({ default: 0 }) value!: number

    counter = 0         // incremented on value increases only, so only those show animations
    isLoaded = false    // used to silence animations for the first second (on load)

    mounted() {
        setTimeout(() => {
            this.isLoaded = true
        }, 1000)
    }

    @Watch('value')
    checkCounter(newValue, oldValue) {
        if (newValue > oldValue) {
            this.counter++
        }
    }
}
